import { Injectable } from '@angular/core';
import { ReCaptchaService } from '@app/core/recaptcha/re-captcha.service';
import { MemberService, PublicInfoResponse } from '@app/core/members/member.service';
import { MemberIdentifier } from '@app/core/_models/member-interface';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { RecaptchaAction, RecaptchaData } from '@app/core/recaptcha/recaptcha-commons';

@Injectable({
  providedIn: 'root',
})
export class MemberPublicDataService {

  constructor(private reCaptchaService: ReCaptchaService,
              private memberService: MemberService) { }

  public getMemberPublicInfo(identifier: MemberIdentifier): Observable<PublicInfoResponse> {
    return this.generateScoreBasedReCaptchaKey()
      .pipe(
        switchMap(captchaData => this.lookup(identifier, captchaData)),
      );
  }

  private generateScoreBasedReCaptchaKey(): Observable<RecaptchaData> {
    return this.reCaptchaService.generateToken(RecaptchaAction.register);
  }

  private lookup(identifier: MemberIdentifier, data: RecaptchaData): Observable<PublicInfoResponse> {
    return this.memberService.isMember(identifier, data);
  }
}
